module.exports = __webpack_public_path__ + "static/media/outreach-logo-text.0a77a7ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/outreach-logo-text.svg
// module id = N88K
// module chunks = 89